import EmbeddedCardLayout from '../../../components/embedded/CardLayout';
import EmbeddedStatusBlock from '../../../components/embedded/StatusBlock';
import { type AppLogoBadgeKind } from '../../../components/shared/AppLogoBadge';
import EmbeddedNeedHelpSection, {
  type HelpLink,
} from '../../../components/embedded/NeedHelpSection';
import { type FlowAction, type AppInfo } from '../../../types';

type StatusScreenProps = {
  visual: 'app' | 'help' | 'clock' | 'alert';
  app?: AppInfo;
  badge?: AppLogoBadgeKind;
  title: string;
  sub: string;
  primary?: FlowAction;
  secondary?: FlowAction;
  links?: HelpLink[];
};

/** A compact status screen: visual, two lines, buttons and help links. */
export default function EmbeddedStatusScreen({
  primary,
  secondary,
  links,
  ...status
}: StatusScreenProps) {
  return (
    <EmbeddedCardLayout
      primary={primary}
      secondary={secondary}
      help={links && <EmbeddedNeedHelpSection links={links} />}
    >
      <EmbeddedStatusBlock {...status} />
    </EmbeddedCardLayout>
  );
}
